``;
import { Injectable, signal, computed } from '@angular/core';
import { delay } from 'rxjs/operators';

import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';
import { AppDomService } from 'src/app/core/services/dom.service';
import { GetUserOrganizationsDto, UserStateDto } from '../../api/models';
import { UsersService } from '../../api/services';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  #userState = signal<UserStateDto>({});
  #isImpersonateMode = signal<boolean>(false);
  #isRefreshingToken = signal<boolean>(false);
  #isChangePasswordRequired = signal<boolean>(false);
  #isUpdatingRefreshToken = signal<boolean>(false);
  #userOrganizations = signal<GetUserOrganizationsDto[]>([]);

  isFetchingUserOrganizations: boolean = false;
  isFetchingOrganizationCredit: boolean = false;
  isFetchingNotifications: boolean = false;
  isShowErr401Dialog: boolean = false;

  userState = computed(this.#userState);
  isImpersonateMode = computed(this.#isImpersonateMode);
  isRefreshingToken = computed(this.#isRefreshingToken);
  isUpdatingRefreshToken = computed(this.#isUpdatingRefreshToken);
  userOrganizations = computed(this.#userOrganizations);
  isChangePasswordRequired = computed(this.#isChangePasswordRequired);

  constructor(private userService: UsersService) {}

  //#region set behavior subject

  setUserState(userState: UserStateDto) {
    this.#userState.set(userState);
  }

  setChangePasswordRequired(changePasswordRequired: boolean) {
    this.#isChangePasswordRequired.set(changePasswordRequired);
  }

  setIsImpersonateMode(isImpersonate: boolean) {
    this.#isImpersonateMode.set(isImpersonate);
  }

  setRefreshingToken(isRefreshToken: boolean) {
    this.#isRefreshingToken.set(isRefreshToken);
  }

  setUpdatingRefreshToken(isUpdatingRefreshToken: boolean) {
    this.#isUpdatingRefreshToken.set(isUpdatingRefreshToken);
  }

  setUserOrganizations(userOrganizations: GetUserOrganizationsDto[]) {
    this.#userOrganizations.set(userOrganizations);
  }

  //#endregion

  getUserStateApi() {
    // show main init loading
    AppDomService.hideAppScroll();

    //delay for loading display
    this.userService
      .usersGetUserState()
      .pipe(delay(3000))
      .subscribe(
        (res) => {
          // res.changePasswordRequired=true;

          this.setChangePasswordRequired(res.data?.changePasswordRequired);

          if (res == null) this.#userState.set({});
          else this.#userState.set(res.data);

          if (localStorage.getItem(LocalStorageKeys.activeOrganizationId))
            localStorage.removeItem(LocalStorageKeys.activeOrganizationId);
        },
        (error) => {
        }
      );
  }
}
